import { faker } from '@faker-js/faker'

import {
  AdminTreatmentOption,
  AdminTreatmentRequestOption,
  TreatmentOption,
  UserTreatmentOption,
} from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getAdminTreatmentItemOfOption = asBuilder((): AdminTreatmentOption => {
  return {
    id: faker.number.int(),
    unitProperty: {
      id: faker.string.uuid(),
      name: faker.string.uuid(),
      enabled: faker.datatype.boolean(),
      value: faker.number.int(),
    },
    priceProperties: {
      items: faker.helpers.multiple(() => ({
        id: faker.string.uuid(),
        name: faker.string.uuid(),
        enabled: faker.datatype.boolean(),
        values: {
          items: faker.helpers.multiple(() => ({
            id: faker.string.uuid(),
            name: faker.string.uuid(),
          })),
        },
      })),
    },
    ...getTreatmentItemOfOption(),
  }
})

export const getAdminTreatmentItemOfRequestOption = asBuilder((): AdminTreatmentRequestOption => {
  return {
    id: faker.number.int(),
    unitProperty: {
      id: faker.string.uuid(),
      value: faker.number.int(),
    },
    priceProperties: {
      items: faker.helpers.multiple(() => ({
        id: faker.string.uuid(),
        values: {
          items: faker.helpers.multiple(() => ({
            id: faker.string.uuid(),
          })),
        },
      })),
    },
    ...getTreatmentItemOfOption(),
  }
})

export const getTreatmentItemOfOption = asBuilder((): TreatmentOption => {
  return {
    name: faker.string.uuid(),
    times: {
      value: faker.number.int({ min: 1, max: 10 }),
      type: 'NUMBER_OF_TIMES',
    },
    material: { name: faker.string.uuid() },
  }
})

export const getUserTreatmentItemOfOption = asBuilder((): UserTreatmentOption => {
  return {
    id: faker.string.uuid(),
    unitProperty: {
      id: faker.string.uuid(),
      name: faker.string.uuid(),
      value: faker.number.int(),
    },
    priceProperties: faker.helpers.multiple(() => ({
      id: faker.string.uuid(),
      name: faker.string.uuid(),
      values: faker.helpers.multiple(() => ({
        name: faker.commerce.productName(),
        id: faker.string.uuid(),
      })),
    })),
    ...getTreatmentItemOfOption(),
  }
})
